
let eventsData;

export default async function getEvents() {
    if (eventsData) {
        return eventsData;
    }

    try {
        eventsData = fetch('/api/events.json')
            .then(res => res.json())
            .then(data => processEvents(data.docs));

        return eventsData;
    } catch (error) {
        console.error('Failed to load events:', error);

        throw error;
    }
}

function processEvents(events) {
    return events;
}
